var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelectIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2371 19.9027C13.1695 19.8367 12.8801 19.5878 12.6421 19.356C11.1453 17.9967 8.69531 14.4506 7.94747 12.5947C7.82731 12.3128 7.57297 11.6002 7.55664 11.2194C7.55664 10.8546 7.64064 10.5068 7.81097 10.1749C8.04897 9.76124 8.42347 9.42937 8.86564 9.24752C9.17247 9.13046 10.0906 8.94861 10.107 8.94861C11.1115 8.76676 12.7436 8.66675 14.5473 8.66675C16.2658 8.66675 17.8315 8.76676 18.8511 8.91565C18.8675 8.9327 20.0085 9.11455 20.3993 9.31344C21.1133 9.67828 21.5566 10.3909 21.5566 11.1535V11.2194C21.5391 11.7161 21.0958 12.7606 21.0795 12.7606C20.3305 14.5166 18.0006 17.9808 16.4525 19.373C16.4525 19.373 16.0546 19.7651 15.8061 19.9356C15.4491 20.2016 15.007 20.3334 14.5648 20.3334C14.0713 20.3334 13.6116 20.1845 13.2371 19.9027Z",
    fill: "#414141"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectIcon);
export default __webpack_public_path__ + "static/media/select-icon.2d1c2ef3f74ae33588334b435fe87fef.svg";
export { ForwardRef as ReactComponent };